import { Grid, Typography, Card, CardContent, SvgIcon } from '@mui/material';
import { COLOR_BLACK_PERL } from '../../popTheme';

export const ResultsCard = ({ background, title, score, icon, description }) => {
  return (
    <Card
      sx={{
        padding: '1.25rem',
        minHeight: { xs: '28rem', md: '25.25rem' },
        minWidth: '20.5rem',
        width: 'auto',
        borderRadius: '0.75rem',
        background,
      }}
    >
      <CardContent>
        <Grid container>
          <Grid
            container
            justifyContent={'space-between'}
            borderBottom={1}
            borderColor={COLOR_BLACK_PERL}
            paddingBottom={'1.25rem'}
          >
            <Typography variant="h5" color={COLOR_BLACK_PERL}>
              {title}
            </Typography>
            <Typography variant="h5" color={COLOR_BLACK_PERL}>
              {score}
            </Typography>
          </Grid>
          <Grid container justifyContent={'space-around'}>
            <SvgIcon
              component={icon}
              inheritViewBox
              color={COLOR_BLACK_PERL}
              sx={{
                marginY: '2rem',
                height: '3.75rem',
                width: '3.75rem',
                fill: COLOR_BLACK_PERL,
              }}
            />
          </Grid>
          <Typography variant="body" color={COLOR_BLACK_PERL} sx={{ lineHeight: '175%' }}>
            {description}
          </Typography>
        </Grid>
      </CardContent>
    </Card>
  );
};
